<template>
    <div class="form-panel input" id="contact">
        <header class="input-header">
            <p>Contact a SIMPAS-applied Solutions Specialist to determine how SaS can save you time and make you&nbsp;money.</p>
        </header>
        <div class="content">
            <a href="https://www.simpas.com/contact-us" class="btn">Contact Us</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped lang="sass">
@import ../assets/sass/includes/variables
#contact
    background: #F5F5F5
    padding-bottom: 2rem
    box-shadow: none
    width: 100%
    max-width: 500px
    text-align: center
    +breakpoint(min-width $desk-xm)
        +breakpoint(max-width $desk)
            padding: 0.5rem 2rem 2rem
    header
        p
            margin: 0 auto 2rem
            line-height: 24px
            max-width: 300px
    .content
        +breakpoint(max-width $desk)
            padding-bottom: 0
    .btn
        text-transform: capitalize
        max-width: 240px
        +breakpoint($desk-xm)
            font-size: 1.1rem
        +breakpoint($desk-lg)
            font-size: 1.3rem
</style>